// extracted by mini-css-extract-plugin
export default {"Projects":"Projects_Projects__4uHmJ","Projects__Header":"Projects_Projects__Header__N4I2g","Projects__Project_Tiles":"Projects_Projects__Project_Tiles__X9jvx"};